import sysFileChoose from '../../components/sys-file-choose/index.vue';
const download = require("downloadjs");
export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            searchContent: "",
            pageIndex: 1,
            pageSize: 12,
            total: 0,
            tableData: [],
            multipleSelection: [],
            dialogManageShow: false,
            manageForm: {},
            postList: [],
            fileChooseDialogShow: false,
            dialogFileListVisible: false
        }
    },
    components: { sysFileChoose },
    mounted: function () {
        this.query();
    },
    methods: {
        /**
         * 点击事件
         * @param {*} id 
         */
        clickEvent: function (id, data) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    this.queryPost();
                    this.manageForm = { fileList: [] };
                    this.dialogManageShow = true;
                    break;
                case "edit": //编辑
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.queryFileInfoList(1, this.multipleSelection[0].id);
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.fileList == null || this.manageForm.fileList.length == 0) {
                                this.$message.closeAll();
                                this.$message.warning("关联培训资料不能为空");
                            } else
                                this.saveOrUpdate();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的策略, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => { });
                    break;
                case "fileChoose"://文件选择
                    this.fileChooseDialogShow = true;
                    break;
                case "trainFileShow"://查看策略关联文件
                    this.queryFileInfoList(2, data.id);
                    break;
                case "download": //下载
                    download(this.$global.baseUrl + data.path);
                    break;
                default:
                    break;
            }
        },

        onPopoverShow: function (data) {
            this.queryFileInfoList(2, data.id);
        },

        /**
         * 关闭文件选择弹框
         */
        onFileChooseDialogClose: function () {
            this.fileChooseDialogShow = false;
        },

        /**
         * 选择文件完成回调
         * @param {*} selectedFileList 
         */
        onFileChooseCallback: function (selectedFileList) {
            this.fileChooseDialogShow = false;
            this.manageForm.fileList = selectedFileList;
        },

        /**
         * 移除已选中文件
         * @param {*} item 
         */
        removeSelectFile: function (item) {
            for (var i = 0; i < this.manageForm.fileList.length; i++) {
                if (this.manageForm.fileList[i].id == item.id) {
                    this.manageForm.fileList.splice(i, 1);
                    this.$forceUpdate();
                    return;
                }
            }
        },

        /**
         * 表格选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function (val) {
            this.multipleSelection = val;
        },

        /**
         * 翻页操作
         */
        handlePageChange: function (val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 获取文件类型图标
         * @param {*} item 
         */
        getFileIconType: function (item) {
            switch (item.fileType) {
                case 2: //视频
                    return require("../../../static/images/ic_file_video.png");
                case 3: //音频
                    return require("../../../static/images/ic_file_audio.png");
                case 4: //office
                    var suffix = item.suffix.toLowerCase();
                    if (suffix == "doc" || suffix == "docx")
                        return require("../../../static/images/ic_file_word.png");
                    else if (suffix == "xlsx" || suffix == "xls")
                        return require("../../../static/images/ic_file_excel.png");
                    else if (suffix == "ppt" || suffix == "pptx")
                        return require("../../../static/images/ic_file_ppt.png");
                    else if (suffix == "txt")
                        return require("../../../static/images/ic_file_txt.png");
                    else if (suffix == "pdf")
                        return require("../../../static/images/ic_file_pdf.png");
                    else
                        return require("../../../static/images/ic_file_default.png");
                default:
                    return require("../../../static/images/ic_file_default.png");
            }
        },

        /**
         * 双击事件
         * @param {*} data 
         */
        dbClickEvent: function (data) {
            if (data.fileType == 1 || data.fileType == 2 || data.fileType == 3 || data.fileType == 4)
                window.open(this.baseUrl + data.path, "_blank");
        },

        /**
         * 查询岗位列表
         */
        queryPost: function () {
            this.$post({
                url: 'org/query',
                params: {
                    orgType: 3
                }
            }).then(response => {
                var postList = new Array;
                response.data.forEach(elem => {
                    var count = 0;
                    postList.forEach(item => {
                        if (elem.name == item.name) {
                            count += 1;
                        }
                    });
                    if (count == 0)
                        postList.push(elem);
                });
                this.postList = postList;
            });
        },

        /**
         * 查询关联文件列表
         */
        queryFileInfoList: function (type, trainStrategyId) {
            this.$post({
                url: 'trainStrategyDetails/query',
                params: {
                    trainStrategyId: trainStrategyId
                }
            }).then(data => {
                this.manageForm.fileList = data;
                setTimeout(() => {
                    if (type == 1)
                        this.dialogManageShow = true;
                    else
                        this.dialogFileListVisible = true;
                }, 300);
            });
        },

        /**
         * 新增或修改
         */
        saveOrUpdate: function () {
            var fileInfoIds = new Array();
            this.manageForm.fileList.forEach(elem => {
                fileInfoIds.push(elem.id);
            });
            this.$post({
                url: "/trainStrategy/saveOrUpdate",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    postName: this.manageForm.postName,
                    fileInfoIds: fileInfoIds
                }
            }, true).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("操作成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function () {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/trainStrategy/delete",
                params: {
                    ids: ids
                }
            }).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function () {
            this.$post({
                url: 'trainStrategy/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        },


    }
}